module.exports = __webpack_public_path__ + "media/1WelcomeDeadBoneGapsQuantified.200c1800.mp3";